/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArticleDto } from './articleDto';


export interface ArticlePriceDto { 
    id?: number;
    price?: number | null;
    conventionalPrice?: number | null;
    point?: number | null;
    isFree?: boolean;
    rating?: number | null;
    articleId?: number;
    article?: ArticleDto;
}

